// IMPORTANT: if you edit this file you will need to update the ci build - Update-UiConfig.ps1

// export const CERTA_API_SERVER: string = 'http://localhost:5001/exploration-pocs/us-central1'; 
export const CERTA_API_SERVER: string = 'https://us-central1-exploration-pocs.cloudfunctions.net';
export const CERTA_API_URL: string = CERTA_API_SERVER + '/proxy';

export const ENVIRONMENT: string = 'DEV';
// export const ENVIRONMENT: string = 'RELEASE';

// if false, just send to console.log
export const SEND_LOGS_TO_SERVER = false;

export const APPLICATION_VERSION: string = '1.0.0.0-AAC';


// WEBPACK FOOTER //
// ./src/config.ts